// A report whose values are still being read or checked. Shown instead of any marker or result, in every portal, so what a
// patient/doctor/navigator sees while waiting is worded the same way. The wording comes from the backend (statusLabel/statusDetail,
// ProcessingStatusMessages.java) so web, doctor portal and notifications cannot drift.
import React from 'react';
import { Link } from 'react-router-dom';

export const HELD_STATUSES = ['READING_SCAN', 'AWAITING_NAVIGATOR_QC'];

export const isHeld = (record) => HELD_STATUSES.includes(record?.processingStatus);

const FALLBACK = {
  READING_SCAN: ['Reading your report', 'We are reading your report. You can close this page; we will let you know when it is ready.'],
  AWAITING_NAVIGATOR_QC: ['Being checked by your navigator', 'A Previu navigator is checking this report against your original, either because part of it was hard to read or because it shows results from several dates. Your results will appear here as soon as that check is done.'],
};

// reviewHref: only the navigator's own screens pass it, to jump straight into the check.
export default function HeldReportNotice({ record, reviewHref }) {
  if (!isHeld(record)) return null;
  const [label, detail] = FALLBACK[record.processingStatus];
  return (
    <div className="alert alert-info" role="status" style={{ marginTop: 6 }}>
      <strong>{record.statusLabel || label}</strong>
      <div>{record.statusDetail || detail}</div>
      {reviewHref && record.processingStatus === 'AWAITING_NAVIGATOR_QC' && (
        <div style={{ marginTop: 6 }}><Link to={reviewHref}>Review now →</Link></div>
      )}
    </div>
  );
}
